var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-list-page',{ref:"listPage",attrs:{"button-config":_vm.buttonConfig,"condition-config":_vm.conditionConfig,"columnCache":"SysLog","columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }